<template>
  <layout-default
    :floatingButton="false"
    @floating-button-action="openSpeedDial"
  >
    <template v-slot:toolbar>
      <templates-filters
        :value="queryParams.q"
        @search-clear="searchClear"
        @search-on:input="searchInput"
        @search-on:run="searchRun"
      />
    </template>
    <div class="templates">
      <v-overlay :value="loading" z-index="4">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <main-user-table
        :headers="headers"
        :items="templates"
        :items-per-page="queryParams.pageSize"
        :server-items-length="pagination.totalCount || -1"
        :page="queryParams.page"
        :row-component="'templates-table-row'"
        @to-user="toTemplate"
        @action:get-data="getDataAction"
      />
      <v-speed-dial
        v-model="fab"
        direction="top"
        :bottom="true"
        :right="true"
        fixed
        transition="slide-y-reverse-transition"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="accent" dark elevation="0" fab large>
            <v-icon size="24" v-if="fab">
              bhi-close
            </v-icon>
            <v-icon size="24" v-else>
              bhi-plus
            </v-icon>
          </v-btn>
        </template>
        <v-btn
          small
          color="primary"
          elevation="0"
          @click="
            newTemplateIsProcedureDateRelated = true
            newTemplatePopup = true
          "
        >
          Target dependent
        </v-btn>
        <v-btn
          small
          color="primary"
          elevation="0"
          @click="
            newTemplateIsProcedureDateRelated = false
            newTemplatePopup = true
          "
        >
          Target independent
        </v-btn>
      </v-speed-dial>
      <v-dialog
        v-model="newTemplatePopup"
        persistent
        max-width="290"
        @click:outside="onClickOutside"
        @keydown="onKeydown"
      >
        <v-card>
          <v-card-title class="headline">Add new sprint</v-card-title>
          <v-card-text>
            <v-text-field
              label="Sprint name"
              v-model="newTemplateName"
              required
            ></v-text-field>
            <v-text-field
              label="Sprint description"
              v-model="newTemplateDescription"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="rounded-pill" text @click="closeNewTemplatePopup"
              >Cancel</v-btn
            >
            <v-btn
              class="rounded-pill elevation-0"
              color="accent"
              :disabled="newTemplateName == '' || newTemplateDescription == ''"
              @click="createNewTemplate"
              >Create</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </layout-default>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LayoutDefault from '@/layouts/LayoutDefault.vue'
import TemplatesFilters from '@/components/timedRelease/TemplatesFilters.vue'
import NewPracticeDialog from '@/components/dialogs/NewPracticeDialog.vue'
import MainUserTable from '@/components/tables/MainUserTable'
import RouterMixin from '@/mixins/router'

export default {
  name: 'TimedRelease',
  components: {
    LayoutDefault,
    TemplatesFilters,
    MainUserTable,
  },
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
        { text: 'Date added', value: 'creationDate' },
      ],
      defaultQueryParams: {
        sortBy: 'name',
        sortDirection: 'asc',
      },
      showNewPracticeDialog: false,
      showSpeedDial: true,
      fab: false,
      newTemplatePopup: false,
      newTemplateName: '',
      newTemplateDescription: '',
      newTemplateIsProcedureDateRelated: false,
    }
  },
  mixins: [RouterMixin],
  computed: {
    ...mapState('templatesStates', [
      'templates',
      'template',
      'loading',
      'pagination',
    ]),
  },
  methods: {
    ...mapActions('templatesStates', ['getTemplates', 'addTemplate']),
    openSpeedDial() {
      this.showSpeedDial = true
    },
    closeSpeedDial() {
      this.showSpeedDial = false
    },
    toTemplate(id) {
      this.$router.push({
        name: 'Template',
        path: '/sprints/:id',
        params: { id: id },
      })
    },
    closeNewTemplatePopup() {
      this.newTemplateName = ''
      this.newTemplateDescription = ''
      this.newTemplatePopup = false
    },
    onClickOutside() {
      this.closeNewTemplatePopup()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.closeNewTemplatePopup()
    },
    createNewTemplate() {
      this.addTemplate({
        name: this.newTemplateName,
        description: this.newTemplateDescription,
        isProcedureDateRelated: this.newTemplateIsProcedureDateRelated,
      }).then(() => {
        this.toTemplate(this.template.id)
      })
    },
    searchClear() {
      this.getDataAction({ ...this.defaultQueryParams })
    },
    searchInput({ key, value }) {
      this.getDataAction({ ...this.defaultQueryParams, [key]: value })
    },
    searchRun(search) {
      this.getDataAction({ ...this.defaultQueryParams, firstName: search })
    },
    getData(data) {
      this.getTemplates(data)
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.templates {
  padding: 2 * $gutter;
  .v-speed-dial {
  }
  .v-speed-dial__list {
    align-items: flex-end;
  }
  .v-dialog {
    margin: 0;
  }
}
</style>
